import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "overlay",
  class: "overlay"
}, null, -1)

import HeaderSection from "./section/HeaderSection.vue";
import PhoneMenu from "./section/PhoneMenuSection.vue";
import MainSection from "./section/MainSection.vue";
import FooterSection from "./section/FooterSection.vue";
import '../../../../public/home_page/css/style.css';
import '../../../../public/home_page/css/reset.css';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-var-requires */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderSection),
    _createVNode(PhoneMenu),
    _hoisted_1,
    _createVNode(MainSection),
    _createVNode(FooterSection)
  ], 64))
}
}

})